import React, { useEffect, useRef, useState } from 'react';
import { Link, useBlocker, useNavigate } from 'react-router-dom';
import { API_URL } from '../../../config/constants';
import axios from 'axios';
import createIconImg from '../../../images/createIcon.png';
import cretaeIconImgOn from '../../../images/createIcon_on.png';

import YouWereEditing from '../../components/YouWereEditing';
import NewModelRow from './components/NewModelRow';
import { useSelector } from 'react-redux';
import {saveAs} from 'file-saver';

function ShowModels({ models }) {
    const [modelList, setModelList] = useState([]);
    const [changed, setChanged] = useState(false);
    const [newRowsArr, setNewRowsArr] = useState([]);
    const [modelTypes, setModelTypes] = useState([]);
    const { login, privilege, userRank, organization } = useSelector((state) => state.session);

    const navigate = useNavigate();
    const modelsTblAreaRef = useRef(null);

    const onCreateNewRow = e => {

        setNewRowsArr(prev => [...prev, {
            modelType: "",
            modelName: "",
            modelNo: "",
            sumDsId: null,
            SumDataStruct: {
                name: null, grpName: [''], indexName: [['']],
            },
            stdVal: [[['None', 'None', 'None']]],
            material: '',
            matThickness: 0,
            tblHeight: 0,
            ectStart: 0,
            ectEnd: 0,
            boltStart: 0,
            boltEnd: 0,
            ect2bolt: 0,
            bolt2dist: 0,
            drawing: "", photo: "", report: "", comment: "", organization: organization
        }]);
        setChanged(true);
        setTimeout(() => {
            if (modelsTblAreaRef.current) {
                modelsTblAreaRef.current.scrollTo({
                    top: modelsTblAreaRef.current.scrollHeight,
                    behavior: 'smooth',
                });
            }
        }, 0);
    }
    // 수정 버튼 이벤트
    const handleCreateObject = async e => {
        e.preventDefault();
        // 수정 사항 id(PK)체크 후 해당 데이터만 전송
        if (newRowsArr.length > 0 && newRowsArr.some(function (x) {
            return x.modelType.length === 0 || x.modelName.length === 0 || x.modelNo.length === 0;
        })) {
            window.alert('새 모델 중 차종/품명/품번을 입력하지 않은 것이 있습니다.');
            return;
        }
        const stdValStringifiedModelList = modelList.map(el => {
            return ({ ...el, stdVal: JSON.stringify(el.stdVal) });
        })
        const convertedNewRows = newRowsArr.map(el => {
            const { SumDataStruct, ...rest } = el;
            return ({ ...rest, stdVal: JSON.stringify(rest.stdVal) });
        });
        const updatedData = stdValStringifiedModelList.filter(x => !models.includes(x));
        const convertedUpdateData = updatedData.map(el => {
            const { SumDataStruct, Organization, ...rest } = el;
            return (rest);
        })
        await axios.post(`${API_URL}/monitoring-manage/updateModels`, { updatedData: convertedUpdateData, newData: convertedNewRows }).then(res => {
            if (res.data.success) {
                // window.location = '/model/edit';
                navigate(0);
                // onReturnDefault(e);
            } else {
                console.error(res.data.error);
            }
        }).catch(err => console.error(err));

    };
    const onReset = e => {
        e.preventDefault();
        setModelList([...models]);
        setNewRowsArr([]);
        setChanged(false);
    };
    const onChange = (e, index) => {
        let copyArr = [...modelList];
        copyArr[index] = { ...copyArr[index], [e.target.name]: e.target.value };
        setModelList(copyArr);
        setChanged(true);
    };

    const onChangeFloat = (e, index) => {
        // const regex = /^[-+]?\d*\.?\d*$/;
        // if (regex.test(e.target.value)) {
        // }
        let copyArr = [...modelList];
        const parsedValue = e.target.value === '' || e.target.value === null ? null : parseFloat(e.target.value);
        copyArr[index] = { ...copyArr[index], [e.target.name]: parsedValue };
        setModelList(copyArr);
        setChanged(true);
    };

    const onChangeStdVal = (e, dataIdx, outerIdx, innerIdx, valueIdx) => {
        // const regex = /^[-+]?\d*\.?\d*$/;
        // if (regex.test(e.target.value)) {
        // }
        const parsedValue = e.target.value === '' || e.target.value === null ? 'None' : parseFloat(e.target.value)
        let copiedArr = [...modelList];
        let copiedStdVal = [...copiedArr[dataIdx]["stdVal"]];
        copiedStdVal[outerIdx][innerIdx][valueIdx] = parsedValue;
        copiedArr[dataIdx] = { ...copiedArr[dataIdx], stdVal: copiedStdVal };
        setModelList(copiedArr);
        setChanged(true);
    }

    const onChangeNew = (e, nrIdx) => {
        let copyArr = [...newRowsArr];
        copyArr[nrIdx] = { ...copyArr[nrIdx], [e.target.name]: e.target.value };
        setNewRowsArr(copyArr);
    };

    const onChangeNewSel = (sel, nrIdx, name) => {
        let copyArr = [...newRowsArr];
        copyArr[nrIdx] = { ...copyArr[nrIdx], [name]: sel.value ?? '' };
        setNewRowsArr(copyArr);
    }

    const onChangeNewSds = (sel, nrIdx) => {
        let copyArr = [...newRowsArr];
        const newStdVal = sel.SumDataStruct.indexNo.map((num) => {
            const innerArr = Array(num).fill(['None', 'None', 'None']);
            return (innerArr);
        })
        copyArr[nrIdx] = { ...copyArr[nrIdx], ...sel, stdVal: newStdVal };
        setNewRowsArr(copyArr);
    }

    // const onChangeNewStdVal = (e, dataIdx, outerIdx, innerIdx, valueIdx) => {
    //     const regex = /^[-+]?\d*\.?\d*$/;
    //     if (regex.test(e.target.value)) {
    //         const parsedValue = e.target.value === '' || e.target.value === null ? 'None' : parseFloat(e.target.value)
    //         console.log(outerIdx, innerIdx, valueIdx)
    //         let copiedArr = [...newRowsArr];
    //         let copiedStdVal = [...copiedArr[dataIdx]["stdVal"]];
    //          console.log(copiedStdVal);
    //         copiedStdVal[outerIdx][innerIdx][valueIdx] = parsedValue;
    //         console.log(copiedStdVal[outerIdx])
    //         copiedArr[dataIdx] = { ...copiedArr[dataIdx], stdVal: copiedStdVal };
    //         setNewRowsArr(copiedArr);
    //         // setChanged(true);
    //     }
    // }
    const onChangeNewStdVal = (e, dataIdx, outerIdx, innerIdx, valueIdx) => {
        // const regex = /^[-+]?\d*\.?\d*$/;
        // if (regex.test(e.target.value)) {
        // }
        const parsedValue =
            e.target.value === '' || e.target.value === null
                ? 'None'
                : parseFloat(e.target.value);

        let copiedArr = [...newRowsArr];

        // ✅ 깊은 복사 (3중 배열 전체)
        const copiedStdVal = copiedArr[dataIdx]["stdVal"].map(outerArr =>
            outerArr.map(innerArr =>
                [...innerArr]
            )
        );

        // ✅ 값 변경
        copiedStdVal[outerIdx][innerIdx][valueIdx] = parsedValue;

        copiedArr[dataIdx] = {
            ...copiedArr[dataIdx],
            stdVal: copiedStdVal,
        };

        setNewRowsArr(copiedArr);
        // setChanged(true);
    };

    const onChangeNewFloat = (e, index) => {
        // const regex = /^[-+]?\d*\.?\d*$/;
        // if (regex.test(e.target.value)) {
        // }
        let copyArr = [...newRowsArr];
        const parsedValue = e.target.value === '' || e.target.value === null ? null : parseFloat(e.target.value);
        copyArr[index] = { ...copyArr[index], [e.target.name]: parsedValue };
        setNewRowsArr(copyArr);
        // setChanged(true);
    };

    const uploadFile = async (file, name, index) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axios.post(`${API_URL}/monitoring-manage/uploadFile`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        let copyArr = [...modelList];
        copyArr[index] = { ...copyArr[index], [name]: response.data.filePath };
        setModelList(copyArr);
        setChanged(true);

        // return response.data.filePath; // 저장된 경로 반환
    };

    const handleDownload = async (e, pathName) => {
        e.preventDefault();
        const fileUrl = `${API_URL}${pathName}`;
        const fileName = fileUrl.split('/').pop();
        saveAs(fileUrl, fileName);
        // const link = document.createElement('a');
        // link.href = fileUrl;
        // console.log(fileUrl);
        // link.setAttribute('download', fileUrl.split('/').pop());
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // await axios.get(fileUrl, {
        //     responseType: 'blob',
        // }).then(res => {
        //     const url = window.URL.createObjectURL(new Blob([res.data]));
        //     console.log(url)
        //     const link = document.createElement('a');
        //     link.href = url;
        //     link.setAttribute(fileUrl.split('/').pop());
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     window.URL.revokeObjectURL(url);
        // }).catch(error => {
        //     console.error('Download failed:', error);
        // })

    };

    async function getModelTypes() {
        await axios.get(`${API_URL}/android/getModelTypes`).then(res => {
            const convertedArr = res.data.map(el => ({ label: el, value: el }));
            setModelTypes([...convertedArr, { label: '직접입력', value: null }]);
        });
    }


    useEffect(() => {
        setModelList([...models.map(el => {
            const stdValArr = JSON.parse(el.stdVal);
            return ({ ...el, stdVal: stdValArr });
        })]);
        getModelTypes();
    }, [models]);
    console.log(modelList)


    const [blockPopup, setBlockPopup] = useState(false);
    let blocker = useBlocker(({ currentLocation, nextLocation }) =>
        changed && login &&
        currentLocation.pathname !== nextLocation.pathname);

    useEffect(() => {
        if (blocker.state === "blocked") {
            setBlockPopup(true);
        } else {
            setBlockPopup(false);
        }
    }, [blocker.state])
    return (
        <React.Fragment>

            <div className='showModelsArea'>
                <p className='path'>데이터 구조 관리<span className='below'>{'>'}</span>모델</p>
                <h2 className='pageTitle'>모델</h2>
                <div className='modelsTblArea' ref={modelsTblAreaRef}>
                    {/* <div className='hintBtn'>
                        ?
                        <div className='hintMsg'><p>셀을 직접 클릭하여 수정이 가능합니다.</p></div>
                    </div> */}
                    <ul className='modelsTbl'>
                        <li className='row th'>
                            <ul>
                                <li className='col modelType'>차종</li>
                                <li className='col modelName'>품명</li>
                                <li className='col modelNo'>품번</li>
                                <li className='col sumDataName'>공정요약</li>
                                <li className='col grpName'>데이터 그룹</li>
                                <li className='col indexName'>세부 데이터</li>
                                <li className='col stdVal'>기준값</li>
                                <li className='col okNgTolP'>오차 상한</li>
                                <li className='col okNgTolM'>오차 하한</li>
                                <li className='col material'>재질</li>
                                <li className='col matThickness'>소재두께</li>
                                <li className='col tblHeight'>다이높이</li>
                                <li className='col ectStart'>ECT시작</li>
                                <li className='col ectEnd'>ECT종료</li>
                                <li className='col boltStart'>하중시작</li>
                                <li className='col boltEnd'>하중종료</li>
                                <li className='col ect2bolt'>소재to하중</li>
                                <li className='col bolt2dist'>하중to치수</li>
                                <li className='col drawing'>도면</li>
                                <li className='col photo'>사진</li>
                                <li className='col report'>관련문서</li>
                                <li className='col comment'>코멘트</li>
                                {userRank <= 20 ? <li className='col organization'>소속</li> : null}
                            </ul>
                        </li>
                        {
                            modelList.map((element, index, array) => {
                                return (
                                    <li key={index} className='row'>
                                        <ul>
                                            <li className='col modelType'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.modelType} name='modelType' onChange={e => onChange(e, index)} disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col modelName'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.modelName} name='modelName' onChange={e => onChange(e, index)} disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col modelNo'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.modelNo} name='modelNo' onChange={e => onChange(e, index)} disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col sumDataName'>
                                                <div className='colArea'>
                                                    <p>{element.SumDataStruct.name}</p>
                                                </div>
                                            </li>
                                            <li className='col grpName'>
                                                <ul>
                                                    {
                                                        element.SumDataStruct.grpName.map((name, idx) => {
                                                            return (
                                                                <li className='innerCol' key={`grpName_${index}_${idx}`} style={{ height: `${27 * element.SumDataStruct.indexNo[idx]}px` }}>
                                                                    <div className='colArea'>
                                                                        <p>{name}</p>
                                                                    </div>
                                                                </li>);
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                            <li className='col indexName'>
                                                <ul>
                                                    {
                                                        element.SumDataStruct.indexName.map((outerArr, outerIdx) => {
                                                            return (<li key={`indexName_${index}_${outerIdx}`}>
                                                                <ul className='indexLevelUl'>
                                                                    {
                                                                        outerArr.map((name, innerIdx) => {
                                                                            return (
                                                                                <li className='innerCol' key={`indexName_${index}_${outerIdx}_${innerIdx}`}>
                                                                                    <div className='colArea'>
                                                                                        <p>{name}</p>
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>)
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                            <li className='col stdVal'>
                                                <ul>
                                                    {
                                                        element.stdVal.map((outerArr, outerIdx) => {
                                                            return (<li key={`stdVal_${index}_${outerIdx}`}>
                                                                <ul className='indexLevelUl'>
                                                                    {
                                                                        outerArr.map((innerArr, innerIdx) => {
                                                                            return (
                                                                                <li className='innerCol' key={`stdVal_${index}_${outerIdx}_${innerIdx}`}>
                                                                                    <div className='inputArea'>
                                                                                        <input
                                                                                            value={innerArr[0] !== 'None' ? innerArr[0] : ''}
                                                                                            onChange={e => onChangeStdVal(e, index, outerIdx, innerIdx, 0)}
                                                                                        // onBlur={onBlurStdVal}
                                                                                        />
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>)
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                            <li className='col okNgTolP'>
                                                <ul>
                                                    {
                                                        element.stdVal.map((outerArr, outerIdx) => {
                                                            return (<li key={`okNgTolP_${index}_${outerIdx}`}>
                                                                <ul className='indexLevelUl'>
                                                                    {
                                                                        outerArr.map((innerArr, innerIdx) => {
                                                                            return (
                                                                                <li className='innerCol' key={`okNgTolP_${index}_${outerIdx}_${innerIdx}`}>
                                                                                    <div className='inputArea'>
                                                                                        <input
                                                                                            value={innerArr[1] !== 'None' ? innerArr[1] : ''}
                                                                                            onChange={e => onChangeStdVal(e, index, outerIdx, innerIdx, 1)}
                                                                                        // onBlur={onBlurStdVal}
                                                                                        />
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>)
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                            <li className='col okNgTolM'>
                                                <ul>
                                                    {
                                                        element.stdVal.map((outerArr, outerIdx) => {
                                                            return (<li key={`okNgTolM_${index}_${outerIdx}`}>
                                                                <ul className='indexLevelUl'>
                                                                    {
                                                                        outerArr.map((innerArr, innerIdx) => {
                                                                            return (
                                                                                <li className='innerCol' key={`okNgTolM_${index}_${outerIdx}_${innerIdx}`}>
                                                                                    <div className='inputArea'>
                                                                                        <input
                                                                                            value={innerArr[2] !== 'None' ? innerArr[2] : ''}
                                                                                            onChange={e => onChangeStdVal(e, index, outerIdx, innerIdx, 2)}
                                                                                        // onBlur={onBlurStdVal}
                                                                                        />
                                                                                    </div>
                                                                                </li>
                                                                            );
                                                                        })
                                                                    }
                                                                </ul>
                                                            </li>)
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                            <li className='col material'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.material} name='material' onChange={e => onChange(e, index)} disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col matThickness'>
                                                <div className='inputArea'>
                                                    <input value={element.matThickness ?? ''} name='matThickness' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col tblHeight'>
                                                <div className='inputArea'>
                                                    <input value={element.tblHeight ?? ''} name='tblHeight' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col ectStart'>
                                                <div className='inputArea percent'>
                                                    <input value={element.ectStart ?? ''} name='ectStart' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                    <span>%</span>
                                                </div>
                                            </li>
                                            <li className='col ectEnd'>
                                                <div className='inputArea percent'>
                                                    <input value={element.ectEnd ?? ''} name='ectEnd' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                    <span>%</span>
                                                </div>
                                            </li>
                                            <li className='col boltStart'>
                                                <div className='inputArea percent'>
                                                    <input value={element.boltStart ?? ''} name='boltStart' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                    <span>%</span>
                                                </div>
                                            </li>
                                            <li className='col boltEnd'>
                                                <div className='inputArea percent'>
                                                    <input value={element.boltEnd ?? ''} name='boltEnd' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                    <span>%</span>
                                                </div>
                                            </li>
                                            <li className='col ect2bolt'>
                                                <div className='inputArea'>
                                                    <input value={element.ect2bolt ?? ''} name='ect2bolt' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col bolt2dist'>
                                                <div className='inputArea'>
                                                    <input value={element.bolt2dist ?? ''} name='bolt2dist' onChange={e => onChangeFloat(e, index)} type='number' step='0.001' disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            <li className='col drawing'>
                                                <div className='inputArea'>
                                                    {
                                                        element.drawing !== null ?
                                                            <button className='downloadFileBtn' onClick={e => handleDownload(e, element.drawing ?? '')} disabled={element.drawing !== (models[index])?.drawing}>다운로드</button> : null
                                                    }
                                                    <label htmlFor={`drawing_${index}`}>업로드</label>
                                                    <input
                                                        id={`drawing_${index}`}
                                                        type="file"
                                                        accept="image/*,application/pdf" // 필요시 확장
                                                        onChange={e => uploadFile(e.target.files[0], 'drawing', index)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            </li>
                                            <li className='col photo'>
                                                <div className='inputArea'>
                                                    {
                                                        element.photo !== null ?
                                                            <button className='downloadFileBtn' onClick={e => handleDownload(e, element.photo ?? '')} disabled={element.photo !== (models[index])?.photo}>다운로드</button> : null
                                                    }
                                                    <label htmlFor={`drawing_${index}`}>업로드</label>
                                                    <input
                                                        id={`drawing_${index}`}
                                                        type="file"
                                                        accept="image/*,application/pdf" // 필요시 확장
                                                        onChange={e => uploadFile(e.target.files[0], 'photo', index)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            </li>
                                            <li className='col report'>
                                                <div className='inputArea'>
                                                    {
                                                        element.report !== null ?
                                                            <button className='downloadFileBtn' onClick={e => handleDownload(e, element.report ?? '')} disabled={element.report !== (models[index])?.report}>다운로드</button> : null
                                                    }
                                                    <label htmlFor={`drawing_${index}`}>업로드</label>
                                                    <input
                                                        id={`drawing_${index}`}
                                                        type="file"
                                                        accept="image/*,application/pdf" // 필요시 확장
                                                        onChange={e => uploadFile(e.target.files[0], 'report', index)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            </li>
                                            <li className='col comment'>
                                                <div className='inputArea'>
                                                    <input type="text" value={element.comment ?? ''} name='comment' onChange={e => onChange(e, index)} disabled={!privilege?.model.edit} />
                                                </div>
                                            </li>
                                            {userRank <= 20 ? <li className='col organization'>{element.Organization?.name}</li> : null}
                                        </ul>
                                    </li>
                                );
                            })
                        }
                        {
                            newRowsArr.map((newRow, nrIdx) => {
                                return (<NewModelRow
                                    key={`newRow_${nrIdx}`}
                                    newRow={newRow}
                                    nrIdx={nrIdx}
                                    onChangeNew={onChangeNew}
                                    onChangeNewSel={onChangeNewSel}
                                    onChangeNewSds={onChangeNewSds}
                                    onChangeNewStdVal={onChangeNewStdVal}
                                    onChangeNewFloat={onChangeNewFloat}
                                    newRowsArr={newRowsArr}
                                    modelTypes={modelTypes}
                                />);
                            })

                        }
                    </ul>
                </div>
                {
                    privilege?.model.edit ?
                        <div className='btnsArea cscBtns'>
                            <button className={'createBtn'} onClick={onCreateNewRow}>추가<img src={createIconImg} alt={"추가"} /></button>
                            <button className='editBtn' onClick={handleCreateObject} disabled={!changed}>저장</button>
                            <button className='cancelBtn' onClick={onReset} disabled={!changed}>취소</button>
                        </div> : null
                }
            </div>
            <YouWereEditing
                isOpen={blockPopup}
                onRequestClose={e => { e.preventDefault(); blocker.reset(); }}
                onSubmit={e => { e.preventDefault(); blocker.proceed(); }}
            />
        </React.Fragment>
    );
}

export default ShowModels;